/**
 * Mixin for handling field dependencies and validation logic
 */
export default {
  methods: {
    /**
     * Check if a field should be disabled based on its dependencies
     */
    isFieldDisabled(report, field) {
      // If field has no dependency, it's not disabled
      if (!field.dependency) {
        return false;
      }

      // Find the dependency field in the same report
      const dependencyField = report.fields.find(f => f.dropdownOptionsType === field.dependency);
      
      // If dependency field doesn't exist or has no selected value, disable this field
      return !dependencyField || !dependencyField.selectedOption;
    },

    /**
     * Check if a changed field has any dependent fields
     */
    hasDependentFields(report, changedField) {
      // Only check for dependencies if the changed field has a dropdownOptionsType
      if (!changedField.dropdownOptionsType) {
        return false;
      }
      
      // Check if there are any OTHER fields that have a dependency matching the changed field's dropdownOptionsType
      return report.fields.some(field => 
        field !== changedField && 
        field.dependency === changedField.dropdownOptionsType
      );
    },

    /**
     * Clear fields that depend on the changed field
     */
    clearDependentFields(report, changedField) {
      // Find all OTHER fields that have a dependency matching the changed field's dropdownOptionsType
      const dependentFields = report.fields.filter(field => 
        field !== changedField && 
        field.dependency === changedField.dropdownOptionsType
      );
      
      // Clear the selected option for dependent fields
      dependentFields.forEach(field => {
        field.selectedOption = null;
      });
    },

    /**
     * Find a report by its reportType
     */
    findReportByType(reportType) {
      // Find the report with the given reportType in the current value
      for (const card of this.value) {
        for (const section of card.sections) {
          const report = section.reports.find(r => r.reportType === reportType);
          if (report) {
            return report;
          }
        }
      }
      return null;
    },

    /**
     * Check if download should be disabled based on field selections
     */
    downloadDisabled(report) {
      let downloadDisabled = false;

      if (report.fields) {
        // Check that all select fields have been selected
        const selectFields = report.fields.filter(field => field.type === 'select');
        
        // All select fields must have a selected option
        for (const field of selectFields) {
          if (!field.selectedOption) {
            downloadDisabled = true;
            break;
          }
        }
      }

      return downloadDisabled;
    }
  }
};
